<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M8.5 5.125L9.06355 4.56878C10.8219 2.8104 13.6728 2.81041 15.4312 4.56878C17.1896 6.32715 17.1896 9.17808 15.4312 10.9365L14.875 11.5M5.125 8.5L4.56878 9.06355C2.8104 10.8219 2.81041 13.6728 4.56879 15.4312C6.32715 17.1896 9.17807 17.1896 10.9365 15.4312L11.5 14.875M8.5 11.5L11.5 8.5" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'LinkTextIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>